import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import DashboardHeader from "@components/Header/DashboardHeader";
import GenericBreadCrums from "@components/Breadcrumbs";
// import bgImage from "../../assets/images/BG.svg";
import { useNavigate } from "react-router-dom";

export const ApplicationFailed: React.FC = () => {
  const breadcrumbData = [{ label: "Application Details", link: "#" }];
  const navigate = useNavigate();

  return (
    <Box
      className="login-root"
      sx={{
        // background: `url(${bgImage}) no-repeat top center`,
        backgroundSize: "cover",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column"
      }}
    >
      {/* Header and Breadcrumb */}
      <div className="page-content">
        {/* <DashboardHeader /> */}
        <GenericBreadCrums breadcrumbs={breadcrumbData} className="mt-6" />

        {/* Main Failed Box */}
        <Box
          sx={{
            mt: 4,
            mx: 3,
            backgroundColor: "#FFFFFF",
            borderRadius: "12px",
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "75vh"
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              p: { xs: 3, md: 6 }
            }}
          >
            {/* Red Cross Icon */}
            <CancelIcon
              sx={{
                color: "#B3261D",
                width: 80,
                height: 80,
                mb: 3
              }}
            />

            {/* Failed Message */}
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontSize: "18px",
                color: "#000000",
                mb: 4
              }}
            >
              Your transaction could not be processed. Please try again or
              verify your payment details.
            </Typography>

            {/* Go Back Button */}
            <Button
              variant="contained"
              onClick={() => navigate("/application-dashboard")}
              sx={{
                backgroundColor: "#4B0082",
                color: "#fff",
                textTransform: "none",
                borderRadius: "24px",
                px: 4,
                py: 1.2,
                fontWeight: 500,
                fontSize: "14px",
                "&:hover": {
                  backgroundColor: "#3A1C73"
                }
              }}
            >
              Go Back to Dashboard
            </Button>
          </Box>
        </Box>
      </div>
    </Box>
  );
};

export default ApplicationFailed;
